<template>
  <div class="coache-head-blk" id="my-matches">
    <div class="row align-items-center">
      <div class="col-md-5">
        <div class="court-table-head">
          <h4>Trận đấu của bạn</h4>
          <p>Xem lịch thi đấu của bạn: {{ pagination?.total ?? 0 }} trận đấu</p>
        </div>
      </div>
      <div class="col-md-7">
        <div class="table-search-top">
          <div id="tablefilter">
            <div class="dataTables_filter">
              <label>
                <input v-model="keyword" class="form-control form-control-sm" placeholder="Tìm kiếm"
                       type="search">
              </label>
            </div>
          </div>
          <div class="request-coach-list">
            <div class="card-header-btns">
              <nav>
                <div class="nav nav-tabs" role="tablist">
                  <button id="nav-Recent-tab" class="nav-link active" type="button" @click="searchKeyword">
                    Tìm kiếm
                  </button>
                </div>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div
      id="nav-Recent"
      aria-labelledby="nav-Recent-tab"
      class="tab-pane fade show active"
      role="tabpanel"
      tabindex="0"
  >
    <div class="table-responsive table-datatble">
      <table class="table table-borderless dashboard-card-table">
        <thead class="thead-light">
        <tr>
          <th>Giải đấu</th>
          <th>Thời gian</th>
          <th>Mã trận</th>
          <th>Địa điểm</th>
          <th>Trạng thái</th>
          <th>Tỉ số</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="match in User_Match" :key="match.id">
          <td>
            <h2 class="table-avatar">
                <span class="table-head-name flex-grow-1">
                  <a href="javascript:void(0);" @click="openModal(match.originData)">{{
                      match.Tour
                    }}</a>
                </span>
            </h2>
          </td>
          <td>
            <p>{{ match.Date }}</p>
            <p>{{ match.Time }}</p>
          </td>
          <td>
            <h6>{{ match.Code }}</h6>
          </td>
          <td>{{ match.Arena }}</td>
          <td>
            <span :class="match.Style"> {{ match.Status }}</span>
          </td>
          <td>
            <h3>{{ match.Score }}</h3>
          </td>
          <td></td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>

  <div class="tab-footer">
    <div class="row">
      <div class="col-md-6">
        <div id="tablelength">
          <div class="dataTables_length">
            <label>Hiển thị
              <select
                  v-model="pagination.pageSize"
                  class="custom-select custom-select-sm form-control form-control-sm"
                  @change="handleTableChange"
              >
                <option value="10">10</option>
                <option value="25">25</option>
                <option value="50">50</option>
                <option value="999999">All</option>
              </select>
            </label>
          </div>
        </div>
      </div>

      <div class="col-md-6">
        <div id="tablepage">
          <div class="dataTables_paginate paging_simple_numbers">
            <ul class="pagination">
              <li
                  :class="{ disabled: pagination.current === 1 }"
                  class="paginate_button page-item previous"
                  @click="changePage(pagination.current - 1)"
              >
                <a class="page-link" href="javascript:void(0);">
                  <i class="feather-chevrons-left"></i>
                </a>
              </li>

              <li
                  v-for="page in totalPages"
                  :key="page"
                  :class="{ active: pagination.current === page }"
                  class="paginate_button page-item"
                  @click="changePage(page)"
              >
                <a class="page-link" href="javascript:void(0);">{{ page }}</a>
              </li>

              <li
                  :class="{ disabled: pagination.current === totalPages }"
                  class="paginate_button page-item next"
                  @click="changePage(pagination.current + 1)"
              >
                <a class="page-link" href="javascript:void(0);">
                  <i class="feather-chevrons-right"></i>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>

  <ModalMatch v-model:visible="showModal" :initial-data="initialData" :style="{ width: '50%', minWidth: '600px' }"/>
</template>

<script>
import {ref, watch, computed} from "vue";
import {useQuery} from "@vue/apollo-composable";
import {GET_TOUR_MATCHES_BY_PLAYER} from "@/graphql/operations/tour-match.ts";
import ModalMatch from "@/components/modal/tour-match-modal.vue";

export default {
  components: {
    ModalMatch,
  },
  setup() {
    /* Danh sách trận đấu */
    const User_Match = ref([]);
    const keyword = ref("");
    const initialData = ref(null);

    const showModal = ref(false);

    /* Phân trang */
    const pagination = ref({
      current: 1,
      pageSize: 10,
      total: 0,
      showSizeChanger: true,
    });

    /* Lấy dữ liệu từ localStorage */
    const player = JSON.parse(localStorage.getItem("player"));
    const playerId = player?.documentId ?? "";

    /* Gọi API với GraphQL */
    const {result: resultTourMatch, refetch} = useQuery(
        GET_TOUR_MATCHES_BY_PLAYER,
        () => ({
          player: playerId,
          page: parseInt(pagination.value.current),
          pageSize: parseInt(pagination.value.pageSize),
          keyword: keyword.value,
        }),
        {fetchPolicy: "network-only"}
    );

    /* Format ngày giờ */
    function formatDateTime(isoString) {
      const date = new Date(isoString);
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0"); // Tháng bắt đầu từ 0
      const year = date.getFullYear();
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");

      return {
        date: `${day}/${month}/${year}`,
        time: `${hours}:${minutes}`,
      };
    }

    /* Theo dõi kết quả từ query và cập nhật User_Match */
    watch(
        resultTourMatch,
        () => {
          if (resultTourMatch?.value?.tourMatches_connection) {
            const tourMatches = resultTourMatch?.value?.tourMatches_connection?.nodes ?? [];
            pagination.value.total = resultTourMatch.value?.tourMatches_connection?.pageInfo.total;

            const arrPlayer = tourMatches.map((match) => {
              const statusMap = {
                NOT_SCHEDULED: {class: "badge bg-secondary", text: "Chưa lên lịch"},
                SCHEDULED: {class: "badge bg-info", text: "Đã lên lịch"},
                ONGOING: {class: "badge bg-primary", text: "Đang diễn ra"},
                PAUSED: {class: "badge bg-warning", text: "Tạm hoãn"},
                COMPLETED: {class: "badge bg-success", text: "Đã kết thúc"},
                CANCELED: {class: "badge bg-danger", text: "Đã huỷ"},
              };

              const status = statusMap[match?.tour_match_status] || statusMap.CANCELED;
              const {date, time} = formatDateTime(match?.start_date);

              return {
                Tour: match?.tournament?.name,
                Date: date,
                Time: time,
                Code: match.match_code,
                Arena: match?.court?.arena?.name ?? "Chưa có thông tin địa điểm",
                Status: status.text,
                Style: status.class,
                Score: match?.score ? JSON.parse(match.score).join(" - ") : "",
                originData: match,
              };
            });

            User_Match.value = arrPlayer;
          } else {
            User_Match.value = [];
            pagination.value.total = 0;
          }
        },
        {deep: true}
    );

    /* Tính toán số trang */
    const totalPages = computed(() => Math.ceil(pagination.value.total / pagination.value.pageSize));

    /* Xử lý thay đổi số lượng bản ghi hiển thị */
    function handleTableChange() {

      pagination.value.current = 1;
      fetchData();
    }

    /* Chuyển trang */
    function changePage(page) {
      if (page < 1 || page > totalPages.value) return;
      pagination.value.current = page;

      fetchData();
    }

    const searchKeyword = () => {
      refetch();
    };

    /* Gọi API khi thay đổi trang hoặc số lượng bản ghi */
    function fetchData() {
      refetch();
    }

    const openModal = (record) => {
      showModal.value = true;
      initialData.value = record;
    }

    return {
      pagination,
      keyword,
      openModal,
      initialData,
      showModal,
      searchKeyword,
      User_Match,
      totalPages,
      handleTableChange,
      changePage,
      fetchData,
    };
  },
};
</script>

